import React from 'react';

const Rating = () => {
  return (
    <>
      <ul className='review-rate mb-0 mt-2 list-unstyled list-inline'>
        <li className='list-inline-item'>
          <i className='fas fa-star text-warning'></i>
        </li>
        <li className='list-inline-item'>
          <i className='fas fa-star text-warning'></i>
        </li>
        <li className='list-inline-item'>
          <i className='fas fa-star text-warning'></i>
        </li>
        <li className='list-inline-item'>
          <i className='fas fa-star text-warning'></i>
        </li>
        <li className='list-inline-item'>
          <i className='fas fa-star text-warning'></i>
        </li>
      </ul>
    </>
  );
};

export default Rating;
